import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function MonetizationOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"monetization_on"}/>
}
